import {
  getFeedbackOrderList,
  getComplaintList,
  getComplaintInfo,
  dealComplaint,
  getFields,
  addComplaint,
  addComplaintDetail,
  addLog,
  getRolesStaffList
} from '@/api/customerComplaint.js'
import { getToken, setToken } from '@/utils/auth'
import { Notify } from 'vant'

const state = {
  token: getToken()
}

const mutations = {
  SET_TOEKN(state, token) {
    state.token = token
  }
}

const actions = {

  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      commit('SET_TOEKN', token)
      setToken(token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      commit('SET_TOEKN', '')
      throw error
    }
  },

  // F-05-反馈订单列表
  getFeedbackOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getFeedbackOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-06-反馈订单问题列表
  getComplaintList(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-07-问题处理详情
  getComplaintInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-08-客诉处理
  dealComplaint(temp, data) {
    return new Promise((resolve, reject) => {
      dealComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 问题选项
  getFields(temp, data) {
    return new Promise((resolve, reject) => {
      getFields(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-04-客户问题反馈
  addComplaint(temp, data) {
    return new Promise((resolve, reject) => {
      addComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-08-问题详情(v2.1)
  addComplaintDetail(temp, data) {
    return new Promise((resolve, reject) => {
      addComplaintDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-09-添加处理过程(v2.1)
  addLog(temp, data) {
    return new Promise((resolve, reject) => {
      addLog(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取服务岗位员工列表(v1.1)
  getRolesStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getRolesStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
